import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import AssignmentForm from "legacy/assignments-v2/AssignmentForm"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import {
  boatDisplayText,
  capitalizeFirstLetter,
  feetToInches,
  inchesToFeet,
  isPresent,
} from "legacy/helpers.es6"
import ReservationStatusHeader from "legacy/manage/ReservationStatusHeader"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import FormSelectCustom from "src/components/Form/FormSelectCustom"
import FormSelectRichOption from "src/components/Form/FormSelectRichOption"
import Modal from "src/components/Modal"

class AssignmentsReservationView extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.reservation = this.props.selectedReservation
    this.contact = this.reservation.contact
    this.contactBoat = this.reservation.contact_boat
    this.arrival = moment(this.reservation.check_in_date, "YYYY-MM-DD")
    this.departure = moment(this.reservation.check_out_date, "YYYY-MM-DD")
    this.spaces = _.flatten(
      _.map(this.props.spacesBySpaceGroups, (spaceGroup) => spaceGroup.spaces)
    )
    this.state = {
      reservationLabelId:
        (this.reservation.reservation_label &&
          this.reservation.reservation_label.id) ||
        "",
      reservationNote: this.reservation.note,
      customerNote: this.contact.note,
      assignments: this.adjustedAssignments(),
      reservationNoteOpen: isPresent(this.reservation.note),
      customerNoteOpen: isPresent(this.contact.note),
      showModal: false,
      saving: false,
      currentAssignmentMeters: this.currentAssignmentMeters(),
    }
    this.addAnother = this.addAnother.bind(this)
    this.removeAssignment = this.removeAssignment.bind(this)
    this.assignmentChange = this.assignmentChange.bind(this)
    this.saveReservation = this.saveReservation.bind(this)
    this.spaceNameForAssignment = this.spaceNameForAssignment.bind(this)
    this.setGlobalState = this.setGlobalState.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
  }

  isDayTrip() {
    return this.arrival.isSame(this.departure)
  }

  handleCloseModal() {
    this.setState({ showModal: false })
  }

  adjustedAssignments() {
    return _.map(this.reservation.assignments, (assignment) => {
      assignment.end_date = moment
        .min(moment(assignment.end_date).add(1, "day"), this.departure)
        .format("YYYY-MM-DD")
      return assignment
    })
  }

  setGlobalState(object) {
    this.setState(object)
  }

  saveReservation() {
    if (this.state.selectingAssignment && this.props.hasLinearDockageEnabled) {
      Amplitude.trackEvent("assignments:linear_dock_save_button_modal", {
        reservation_id: this.reservation.id,
      })
      this.setState({ showModal: true })
    } else {
      if (this.props.comingFromMapView) {
        Amplitude.trackEvent("assignments:map_view_assign_boat", {
          reservation_id: this.reservation.id,
        })
        if (!this.props.comingFromUnassigned) {
          Amplitude.trackEvent("assignments:map_view_reassigned", {
            reaservation_id: this.reservation.id,
          })
        }
      } else {
        Amplitude.trackEvent("assignments:assign_boat", {
          reservation_id: this.reservation.id,
        })
      }
      this.setState({ saving: true })
      const params = {
        assignments: this.getAssignmentsPerNight(),
        note: this.state.reservationNote,
        contact_note: this.state.customerNote,
        reservation_label_id: this.state.reservationLabelId,
      }
      $.ajax({
        url: `${this.props.reservationEndpoint}/${this.reservation.id}/assignments_v2`,
        type: "PATCH",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(params),
        success: (reservation) => {
          this.props.reloadCurrentGrid(() => {
            this.setState({ saving: false })
            this.props.comingFromUnassigned
              ? this.props.openUnassignedReservations()
              : this.props.closeSidebar()
          })
        },
        error: (data) => {
          this.setState({ saving: false })
          const errorMessage =
            data.responseJSON?.errors || "Unable to process, please try again"
          alert(errorMessage)
        },
      })
    }
  }

  getAssignmentsPerNight() {
    let night, spaceId, tmpAssignment, bowLocation, sternLocation
    const nights = _.times(this.departure.diff(this.arrival, "days") + 1)
    return _.map(nights, (nightIndex) => {
      night = this.arrival.clone().add(nightIndex, "days")
      tmpAssignment = _.findLast(this.state.assignments, (assignment) =>
        this.isDayInAssignmentRange(night, assignment)
      )
      spaceId = tmpAssignment ? tmpAssignment.space_id : null
      bowLocation = tmpAssignment ? tmpAssignment.bow_location : null
      sternLocation = tmpAssignment ? tmpAssignment.stern_location : null
      return {
        night: night.format("YYYY-MM-DD"),
        space_id: spaceId,
        bow_location: bowLocation,
        stern_location: sternLocation,
      }
    })
  }

  isDayInAssignmentRange(night, assignment) {
    return (
      this.isDayTrip() ||
      (night.isSame(this.departure) &&
        night.isSameOrAfter(assignment.start_date) &&
        night.isSameOrBefore(assignment.end_date)) ||
      (night.isSameOrAfter(assignment.start_date) &&
        night.isBefore(assignment.end_date))
    )
  }

  assignmentChange(name, value, index, bowLocation, sternLocation) {
    bowLocation = isPresent(bowLocation)
      ? feetToInches(bowLocation)
      : this.state.assignments[index].bow_location
    sternLocation = isPresent(sternLocation)
      ? feetToInches(sternLocation)
      : this.state.assignments[index].stern_location
    const assignments = this.state.assignments
    const space = _.find(this.spaces, { id: value })
    let currentAssignment
    if (space && space.space_group_type !== "SpaceGroup::LinearV2") {
      currentAssignment = {
        ...assignments[index],
        bow_location: null,
        stern_location: null,
      }
    } else {
      currentAssignment = {
        ...assignments[index],
        bow_location: bowLocation,
        stern_location: sternLocation,
      }
    }
    currentAssignment[name] = value
    assignments.splice(index, 1, currentAssignment)
    this.setState({ assignments, selectingAssignment: false })
  }

  removeAssignment(event, index) {
    event.preventDefault()
    const assignments = this.state.assignments
    assignments.splice(index, 1)
    this.setState({ assignments })
  }

  addAnother(event) {
    event.preventDefault()
    let startDate = null
    let endDate = null
    if (this.state.assignments.length === 0) {
      startDate = this.arrival.format("YYYY-MM-DD")
      endDate = this.departure.format("YYYY-MM-DD")
    } else if (
      this.state.assignments[this.state.assignments.length - 1].end_date
    ) {
      const lastAssignment =
        this.state.assignments[this.state.assignments.length - 1]
      startDate = lastAssignment.end_date
      endDate = this.departure.format("YYYY-MM-DD")
    }
    this.setState({
      assignments: this.state.assignments.concat({
        start_date: startDate,
        end_date: endDate,
        space_id: null,
      }),
      selectingAssignment: true,
    })
  }

  isAssignmentContiguous() {
    let startDate = this.arrival
    const endDate = this.departure
    if (this.state.assignments.length === 0) {
      return false
    }
    const isContiguous = _.every(this.state.assignments, (assignment) => {
      if (
        startDate.isSame(moment(assignment.start_date), "day") &&
        isPresent(assignment.space_id)
      ) {
        startDate = moment(assignment.end_date)
        return true
      }
    })
    return isContiguous && startDate.isSame(endDate, "day")
  }

  addNote(name) {
    if (this.props.comingFromMapView) {
      Amplitude.trackEvent(`assignments:map_view_${name}`)
    }
    this.setState({ [name]: true })
  }

  reservationType() {
    if (this.reservation.contract_like) {
      return "Contract"
    } else {
      return "Reservation"
    }
  }

  renderReservationNote() {
    if (this.state.reservationNoteOpen) {
      return (
        <FormGroup
          inputType="textarea"
          label="Reservation Note"
          name="reservationNote"
          value={this.state.reservationNote}
          onChange={this.handleInputChange}
        />
      )
    } else {
      return (
        <div className="form-group flex items-baseline justify-between">
          <label>{`${this.reservationType()} Note`}</label>
          <button
            className="btn btn-secondary btn-sm ml-3"
            type="button"
            onClick={() => this.addNote("reservationNoteOpen")}
          >
            + Add Note
          </button>
        </div>
      )
    }
  }

  renderCustomerNote() {
    if (this.state.customerNoteOpen) {
      return (
        <FormGroup
          inputType="textarea"
          label="Customer Note"
          name="customerNote"
          value={this.state.customerNote}
          onChange={this.handleInputChange}
        />
      )
    } else {
      return (
        <div className="form-group flex items-baseline justify-between">
          <label>Customer Note</label>
          <button
            className="btn btn-secondary btn-sm ml-3"
            type="button"
            onClick={() => this.addNote("customerNoteOpen")}
          >
            + Add Note
          </button>
        </div>
      )
    }
  }

  assignmentContiguousStatus() {
    if (this.isAssignmentContiguous()) {
      return (
        <div className="badge badge-muted ml-3">
          <i className="fa-solid fa-circle-check mr-2 text-teal-700" />
          Fully Assigned
        </div>
      )
    } else {
      return (
        <div className="badge badge-muted ml-3">
          <i className="fa-kit fa-cancel-circle mr-2 text-red-600" />
          Missing Assignments
        </div>
      )
    }
  }

  compareToLastAssignment(assignment, lastAssignment) {
    if (!lastAssignment) {
      return null
    }

    const endOfLastAssignment = moment(lastAssignment.end_date)
    const startOfAssignment = moment(assignment.start_date)
    if (endOfLastAssignment.isSame(startOfAssignment, "day")) {
      return (
        <div
          className="badge badge-muted center mb-4 bg-white"
          style={{ marginTop: -10 }}
        >
          {`Moves ${startOfAssignment.format("dddd MM/DD/YYYY")}`}
        </div>
      )
    } else if (startOfAssignment.isBefore(endOfLastAssignment, "day")) {
      return (
        <div
          className="badge badge-danger center mb-4"
          style={{ marginTop: -10 }}
        >
          {`Overlapping nights ${endOfLastAssignment.format(
            "MM/DD/YYYY"
          )} - ${startOfAssignment.format("MM/DD/YYYY")}`}
        </div>
      )
    } else if (
      endOfLastAssignment.clone().add(1, "day").isSame(startOfAssignment, "day")
    ) {
      return (
        <div
          className="badge badge-muted border-red center mb-4 bg-white"
          style={{ marginTop: -10 }}
        >
          {`Unassigned night of ${endOfLastAssignment.format("MM/DD/YYYY")}`}
        </div>
      )
    } else {
      return (
        <div
          className="badge badge-muted border-red center mb-4 bg-white"
          style={{ marginTop: -10 }}
        >
          {`Unassigned nights ${endOfLastAssignment.format(
            "MM/DD/YYYY"
          )} - ${startOfAssignment
            .clone()
            .subtract(1, "day")
            .format("MM/DD/YYYY")}`}
        </div>
      )
    }
  }

  spaceNameForAssignment(assignment) {
    if (isPresent(assignment.space_id)) {
      const space = _.find(this.spaces, { id: assignment.space_id })
      if (isPresent(assignment.bow_location)) {
        if (isNaN(assignment.bow_location)) {
          return space && `${space.name}, needs assignment`
        } else if (assignment.bow_location > assignment.stern_location) {
          return (
            space &&
            `${space.name}, ${inchesToFeet(
              assignment.stern_location
            )}' - ${inchesToFeet(assignment.bow_location)}'`
          )
        } else {
          return (
            space &&
            `${space.name}, ${inchesToFeet(
              assignment.bow_location
            )}' - ${inchesToFeet(assignment.stern_location)}'`
          )
        }
      } else {
        return space && space.name
      }
    } else {
      return null
    }
  }

  eachAssignmentForm() {
    let lastAssignment, lastAssignmentHtml
    return _.map(this.state.assignments, (assignment, index) => {
      lastAssignmentHtml = this.compareToLastAssignment(
        assignment,
        lastAssignment
      )
      lastAssignment = assignment
      return (
        <AssignmentForm
          key={index}
          index={index}
          arrival={this.arrival}
          departure={this.departure}
          assignment={assignment}
          contactBoat={this.contactBoat}
          spaceName={this.spaceNameForAssignment(assignment)}
          spaceType={this.reservation.requested_space_type}
          loa={this.contactBoat.length_overall}
          lastAssignment={lastAssignment}
          lastAssignmentHtml={lastAssignmentHtml}
          assignmentChange={this.assignmentChange}
          removeAssignment={this.removeAssignment}
          reservationId={this.reservation.id}
          setGlobalState={this.setGlobalState}
          marinaSlug={this.props.marina.slug}
          meterReadingPrompt={() => this.renderMeterReadingPrompt(assignment)}
          isAddingNewAssignment={
            this.state.selectingAssignment && assignment.space == null
          }
        />
      )
    })
  }

  renderWarningModal() {
    return (
      <Modal isOpen={!!this.state.showModal} onClose={this.handleCloseModal}>
        <Modal.Header title="There are currently unsaved assignments." />
        <Modal.Body>
          <p>Some helpful tips for using the assignment tool:</p>
          <ul>
            <li className="mb-2">
              If you are trying to assign a reservation to an exact location on
              a linear dock, press the &quot;Assign&quot; button located to the
              right of the bow and stern locations before saving.
            </li>
            <li>
              {" "}
              If you are trying to assign to any other space type, click on the
              space you would like to assign the reservation to.
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-between space-x-2">
            <button
              type="button"
              onClick={() =>
                this.setState(
                  { showModal: false, selectingAssignment: false },
                  () => this.saveReservation()
                )
              }
              className="btn btn-tertiary"
            >
              Close Without Saving
            </button>
            <button
              type="button"
              onClick={this.handleCloseModal}
              className="btn btn-primary"
            >
              Go Back to Assignment
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  renderElectric() {
    if (this.reservation.electric_product) {
      return (
        <div className="col-xs-6 mb-3">
          <div className="font-bold">Electric</div>
          {this.reservation.electric_product.name}
        </div>
      )
    } else if (
      this.reservation.electrical_rate &&
      this.reservation.electrical_rate.power_type
    ) {
      return (
        <div className="col-xs-6 mb-3">
          <div className="font-bold">Electric</div>
          {this.reservation.electrical_rate &&
            this.reservation.electrical_rate.power_type}
        </div>
      )
    }
    return null
  }

  renderSpecialRequest() {
    if (isPresent(this.reservation.special_request)) {
      return (
        <div className="col-xs-6 mb-3">
          <div className="font-bold">Special Request</div>
          {this.reservation.special_request}
        </div>
      )
    }
    return null
  }

  renderReservationLabel() {
    if (
      this.props.reservationLabels &&
      this.props.reservationLabels.length > 0
    ) {
      return (
        <div className="col-xs-6 mb-3">
          <div className="font-bold">Label</div>
          <FormSelectCustom
            id="reservation-label-select"
            value={this.state.reservationLabelId}
            onChange={(value) => {
              if (this.props.comingFromMapView) {
                Amplitude.trackEvent("reservation_labels:map_view_select")
              }
              this.handleInputChange({
                target: {
                  value,
                  name: "reservationLabelId",
                },
              })
            }}
            autoWidth={false}
          >
            {this.buildLabelOptions(this.props.reservationLabels).map(
              (option) => (
                <FormSelectRichOption key={option.id} value={option.id}>
                  {option.content}
                </FormSelectRichOption>
              )
            )}
          </FormSelectCustom>
        </div>
      )
    }
    return null
  }

  getMetersFromAssignment(assignment) {
    let assignmentForPrompt

    if (assignment.space == null) {
      // new assignment
      const persistedAssignments = this.state.assignments.filter(
        (assignment) => assignment.space != null
      )
      const lastPersistedAssignment =
        persistedAssignments[persistedAssignments.length - 1]

      if (lastPersistedAssignment && lastPersistedAssignment.space) {
        assignmentForPrompt =
          lastPersistedAssignment.space.id === lastPersistedAssignment.space_id
            ? lastPersistedAssignment
            : null
      }
    } else {
      assignmentForPrompt = assignment
    }
    const space = assignmentForPrompt && assignmentForPrompt.space
    return space && space.meters
  }

  renderMeterReadingPrompt(assignment) {
    const meters = this.getMetersFromAssignment(assignment)
    let meterReadingUrl = `/manage/${this.props.marina.slug}/metered_electric`
    let meter

    if (meters) {
      if (meters.length === 1) {
        meter = meters[0]
        meterReadingUrl += `#/meters/${meter.id}/metered_electrics/new`
      }
      return (
        <div
          role="alert"
          className={`my-4 flex items-start justify-between gap-4 rounded-sm border-b border-l-4 border-r border-t border-blue-900 bg-blue-100 p-4 shadow-md`}
        >
          <div className="flex justify-start gap-4">
            <span
              data-testid="alert-banner-icon"
              className={`fa-solid fa-circle-exclamation mt-1 align-middle text-blue-900`}
            />
            <p>
              Do you want to take a{" "}
              <span
                className="cursor-pointer font-semibold text-blue-800 no-underline hover:text-blue-900 hover:no-underline"
                onClick={() => {
                  Amplitude.trackEvent("assignments:click_metered_electric")
                  window.open(meterReadingUrl)
                }}
              >
                final meter reading
              </span>{" "}
              {meter && `at meter ${meter.name}`} before updating this
              assignment?
            </p>
          </div>
        </div>
      )
    }
    return null
  }

  buildLabelOptions(labels) {
    const labelsWithNil = [
      { id: "", label: "None", color: "dark-blue" },
      ...labels,
    ]
    return _.map(labelsWithNil, (label) => {
      label.content = (
        <span className="inline-flex w-full items-center">
          <span
            className={`rl-bg-${label.color}-dark h-3 w-3 flex-shrink-0 rounded-full`}
          />
          <span
            className={classNames("ml-2", {
              truncate: label.label.length > 15,
            })}
          >
            {label.label}
          </span>
        </span>
      )
      return label
    })
  }

  currentAssignmentMeters() {
    const assignmentsIncludingToday = this.reservation.assignments.filter(
      (assignment) =>
        assignment.start_date <= moment().format("YYYY-MM-DD") &&
        assignment.end_date >= moment().format("YYYY-MM-DD")
    )
    let currentAssignment

    if (assignmentsIncludingToday.length === 0) {
      return null
    } else if (
      assignmentsIncludingToday.length === 1 ||
      !this.reservation.checked_in_at
    ) {
      currentAssignment = assignmentsIncludingToday[0]
    } else {
      currentAssignment = assignmentsIncludingToday[1]
    }

    const space = currentAssignment && currentAssignment.space
    return (space && space.meters) || []
  }

  render() {
    return (
      <div className="flex h-screen w-full flex-col justify-start">
        <div
          id="sideBarWindow"
          style={{ overflow: "scroll", paddingBottom: 170 }}
        >
          {this.props.comingFromUnassigned ? (
            <a href="#" onClick={this.props.openUnassignedReservations}>
              &lt; Back
            </a>
          ) : null}
          <h4 className="mt-2 font-semibold">
            {`${this.reservationType()}`}{" "}
            <a
              href={`${this.props.reservationEndpoint}/${this.reservation.encoded_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >{`#${this.reservation.encoded_id}`}</a>
          </h4>
          <ReservationStatusHeader
            status={this.reservation.status}
            displayStatus={this.reservation.meta_status}
            encodedId={this.reservation.encoded_id}
            checkedInAt={this.reservation.checked_in_at}
            checkedOutAt={this.reservation.checked_out_at}
            activityLog={this.reservation.activity_log}
            customerName={this.contact.name}
            boatText={boatDisplayText(
              this.contactBoat.name,
              inchesToFeet(this.contactBoat.length_overall),
              this.contactBoat.boat_type
            )}
            checkInUrl={this.reservation.checkInUrl}
            checkOutUrl={this.reservation.checkOutUrl}
            reloadCurrentGrid={this.props.reloadCurrentGrid}
            marina={this.props.marina}
            comingFromMapView={this.props.comingFromMapView}
            currentAssignmentMeters={this.state.currentAssignmentMeters}
          />
          <div className="bg-light-gray mt-4 p-4">
            <div className="row-flex no-gutters">
              <div className="col-xs-6 mb-3">
                <div className="font-bold">Customer</div>
                {this.contact.name}
              </div>
              <div className="col-xs-6 mb-3">
                <div className="font-bold">Vessel</div>
                {boatDisplayText(
                  this.contactBoat.name,
                  inchesToFeet(this.contactBoat.length_overall),
                  this.contactBoat.boat_type
                )}
              </div>
              <div className="col-xs-6 mb-3">
                <div className="font-bold">Arrival</div>
                {this.arrival.format("dddd MM/DD/YYYY")}
              </div>
              <div className="col-xs-6 mb-3">
                <div className="font-bold">Departure</div>
                {this.departure.format("dddd MM/DD/YYYY")}
              </div>
              <div className="col-xs-6 mb-3">
                <div className="font-bold">Space Type</div>
                {capitalizeFirstLetter(
                  this.reservation.requested_space_type || "Any"
                )}
              </div>
              {this.renderElectric()}
              {this.renderSpecialRequest()}
              {this.renderReservationLabel()}
            </div>
          </div>
          <div className="bg-light-gray mt-4 p-2">
            <div className="mb-2 font-bold">
              Assignments
              {this.assignmentContiguousStatus()}
            </div>
            {this.eachAssignmentForm()}
            <a
              className="mt-3 block p-3 text-center"
              href="#"
              onClick={this.addAnother}
            >
              {this.state.assignments.length > 0
                ? "+ Add another"
                : "+ Add assignment"}
            </a>
          </div>
          <div className="bg-light-gray mt-4 pb-1 pl-4 pr-4 pt-4">
            {this.renderReservationNote()}
            {this.renderCustomerNote()}
          </div>
        </div>
        <div
          className="absolute bottom-0 left-0 right-0 mt-auto border-t bg-white px-4 py-4 xl:sticky xl:-mb-4 xl:px-0"
          style={{ zIndex: 2 }}
        >
          <NextButton
            processing={this.state.saving}
            click={this.saveReservation}
            icon=""
            btnClass="btn btn-primary w-full"
            text="Save"
            processingText="Saving..."
          />
        </div>
        {this.state.showModal &&
          this.props.hasLinearDockageEnabled &&
          this.renderWarningModal()}
      </div>
    )
  }
}

AssignmentsReservationView.propTypes = {
  selectedReservation: PropTypes.object.isRequired,
  spacesBySpaceGroups: PropTypes.array.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  comingFromMapView: PropTypes.bool,
  comingFromUnassigned: PropTypes.bool,
  hasLinearDockageEnabled: PropTypes.bool,
  marina: PropTypes.object.isRequired,
  openUnassignedReservations: PropTypes.func.isRequired,
  reloadCurrentGrid: PropTypes.func.isRequired,
  reservationEndpoint: PropTypes.string.isRequired,
  reservationLabels: PropTypes.array,
}

export default AssignmentsReservationView
